<template>
	<div class="billing-engine-table">
		<v-data-table
			:headers="computedHeaders"
			:items="billingEngineData"
			:items-per-page="100"
			:hide-default-header="$vuetify.breakpoint.xsOnly"
			item-key="transaction_identifier"
			class="elevation-1"
			disable-sort
			hide-default-footer
			no-data-text="There is no data to this filters."
			dense
		>
			<template v-slot:[`item.updated_at`]="{ item }">
				{{ formatDate(item.updated_at) }}
			</template>
			<template v-slot:[`item.created_at`]="{ item }">
				{{ formatDate(item.created_at) }}
			</template>
			<template v-slot:[`item.final_state_set_at`]="{ item }">
				{{ formatDate(item.final_state_set_at) }}
			</template>
			<!-- transaction_type should be converted to "order" if the value is false and "refund" if the value is true -->
			<template v-slot:[`item.transaction_type`]="{ item }">
				{{ item.transaction_type ? 'Refund' : 'Order' }}
			</template>
			<template v-slot:[`item.amount`]="{ item }">
				{{ formatCurrency(item.amount, item.currency) }}
			</template>
			<template v-slot:[`item.discount`]="{ item }">
				{{ formatCurrency(item.discount, item.currency) }}
			</template>
			<template v-slot:[`item.be_coupon_code`]="{ item }">
				{{ addDashIfEmptyString(item.be_coupon_code) }}
			</template>
			<template v-slot:[`item.be_coupon_rule`]="{ item }">
				{{ addDashIfEmptyString(item.be_coupon_rule) }}
			</template>
			<template v-slot:[`item.payment_method`]="{ item }">
				{{ addDashIfEmptyString(item.payment_method) }}
			</template>
			<template v-slot:[`item.payment_provider`]="{ item }">
				{{ addDashIfEmptyString(item.payment_provider) }}
			</template>
			<template v-slot:[`item.external_serviceprovider_id`]="{ item }">
				{{ addDashIfEmptyString(item.external_serviceprovider_id) }}
			</template>
			<template v-slot:[`item.coupon_code`]="{ item }">
				{{ addDashIfEmptyString(item.coupon_code) }}
			</template>
			<template v-slot:[`item.coupon_rule_name`]="{ item }">
				{{ addDashIfEmptyString(item.coupon_rule_name) }}
			</template>
			<template v-slot:[`item.external_ticket_id`]="{ item }">
				{{ addDashIfEmptyString(item.external_ticket_id) }}
			</template>
			<template v-slot:[`item.full_amount_to_pay`]="{ item }">
				{{ formatBoolean(item.full_amount_to_pay) }}
			</template>
		</v-data-table>
	</div>
</template>

<script>
export default {
	name: 'BillingEngineTable',
	props: {
		billingEngineData: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			headers: [
				{
					text: 'Order ID',
					value: 'increment_id',
					selected: true,
					hide: false,
				},
				{
					text: 'Order Item ID',
					value: 'external_order_item_id',
					selected: true,
					hide: false,
				},
				{
					text: 'Transaction ID',
					align: 'start',
					value: 'transaction_id',
					selected: true,
					hide: false,
					/* set the column width */
					width: '350px',
				},
				{
					text: 'Created At',
					value: 'created_at',
					selected: true,
					hide: false,
				},
				{
					text: 'Updated At',
					value: 'updated_at',
					selected: true,
					hide: false,
				},
				{
					text: 'Final State Set At',
					value: 'final_state_set_at',
					selected: true,
					hide: false,
				},
				{
					text: 'Transaction Type',
					value: 'transaction_type',
					selected: true,
					hide: false,
				},
				{
					text: 'Transaction Status',
					value: 'transaction_status',
					selected: true,
					hide: false,
				},
				{
					text: 'Payment Provider',
					value: 'payment_provider',
					selected: true,
					hide: false,
				},
				{
					text: 'Payment Method',
					value: 'payment_method',
					selected: true,
					hide: false,
				},
				/* delete? */
				{
					text: 'Currency',
					value: 'currency',
					selected: true,
					hide: false,
				},
				{
					text: 'Amount',
					value: 'amount',
					selected: true,
					hide: false,
				},
				{
					text: 'Discount',
					value: 'discount',
					selected: true,
					hide: false,
				},
				{
					text: 'Coupon Code',
					value: 'be_coupon_code',
					selected: true,
					hide: false,
				},
				{
					text: 'Coupon Rule',
					value: 'be_coupon_rule',
					selected: true,
					hide: false,
				},
				{
					text: 'Order Date',
					value: 'order_date',
					selected: true,
					hide: false,
				},
				{
					text: 'Product Name',
					value: 'product_name',
					selected: true,
					hide: false,
				},
				{
					text: 'Product SKU',
					value: 'product_sku',
					selected: true,
					hide: false,
				},
				{
					text: 'Customer Firstname',
					value: 'customer_firstname',
					selected: true,
					hide: false,
				},
				{
					text: 'Customer Lastname',
					value: 'customer_lastname',
					selected: true,
					hide: false,
				},
				{
					text: 'Customer Email',
					value: 'customer_email',
					selected: true,
					hide: false,
				},
				{
					text: 'Serviceprovider ID',
					value: 'serviceprovider_id',
					selected: true,
					hide: false,
				},
				{
					text: 'External Serviceprovider ID',
					value: 'external_serviceprovider_id',
					selected: true,
					hide: false,
				},
				{
					text: 'Sales Channel',
					value: 'sales_channel',
					selected: true,
					hide: false,
				},
				{
					text: 'Payment Method',
					value: 'ri_payment_method',
					selected: true,
					hide: false,
				},
				{
					text: 'External Ticket ID',
					value: 'external_ticket_id',
					selected: true,
					hide: false,
				},
				{
					text: 'External ID',
					value: 'external_id',
					selected: true,
					hide: false,
				},
				{
					text: 'Full Amount Paid',
					value: 'full_amount_paid_at_checkout',
					selected: true,
					hide: false,
				},
			],
		}
	},
	watch: {
	},
	computed: {
		computedHeaders() {
			// compute headers from the headers object and take those which are selected and not hidden
			return this.headers.filter((header) => header.selected && !header.hide)
		},
	},
	methods: {
		formatDate(date) {
			return (
				`${new Date(date).toLocaleDateString('en-GB', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				})
				} ${new Date(date).toLocaleTimeString('it-IT', {
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit',
					hour12: false,
				})}`
			)
		},
		formatCurrency(amount, currency = 'EUR') {
			return new Intl.NumberFormat('de-DE', {
				style: 'currency',
				currency,
			}).format(amount)
		},
		addDashIfEmptyString(value) {
			return value === '' || value === null ? '-' : value
		},
		formatBoolean(value) {
			return value ? 'Yes' : 'No'
		},
	},
}
</script>

<style>
.billing-engine-table {
	margin-top: 20px;
	width: 100%;
	max-width: 100%;
	padding-left: 0;
	padding-right: 0;
}
</style>
